export class ResponseMessage<T> {
  response: T;
  errorOccurred: boolean;
  errorCode: string;
  errorDescription: string;

  constructor() {
  }
}
